import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Determines whether an input value is invalid/error
 * @param {String} value - the state value to watch
 * @param {Function} validationFn
 */
const useInputError = (value, validationFn) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const { t } = useTranslation('personalInfo.errorMessage');

  // Validate synchronously without having to wait for state update
  const validate = () => {
    const msg = validationFn();
    const err = !!msg;
    setError(err);
    setMessage(t(msg));

    // return whether there is an error synchronously
    return err;
  };

  // Clear error whenever a user types something
  useEffect(() => {
    setError(false);
    setMessage('');
  }, [value]);

  return { error, message, validate };
};

export default useInputError;
